import { IUser } from '../../../../utils/interfaces/user';
import React from 'react';
import { useLocalization } from 'src/utils/useLocalization';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import './styles.scss';

const Header: React.FC = () => {
    const brand: string = useSelector((state: IUser) => {
        return state.dealerDataInfo?.dealer.brand || 'vw';
    });
    const navigate = useNavigate();

    const { addNewUser } = useLocalization();

    const backClickHandler = () => {
        navigate('/dashboard/systemadmin/dealer-security-maintenance/search');
    };

    return (
        <div className={`sys-header-container__header ${brand.toLowerCase()}`}>
            <div className='one'>
                <button
                    className='c-btn c-btn--link c-btn--small c-btn--simple'
                    onClick={() => backClickHandler()}
                >
                    <i
                        className='c-btn__icon c-icon c-icon--[semantic-back]'
                        aria-hidden='true'
                        role='img'
                    ></i>
                    <span className='c-btn__text'>
                        {addNewUser.HEADER_BUTTON_LABEL}
                    </span>
                </button>
            </div>
        </div>
    );
};

export default Header;
